export default __webpack_public_path__ + "static/media/Long_White.1de6c21b.png";